import firebase from 'firebase'

export const db = firebase
  .initializeApp({
    apiKey: 'AIzaSyAPIU3_xC4AjjAnEAtv-ikvyiMJ0PdjAwE',
    authDomain: 'cards-against-humanity-35251.firebaseapp.com',
    databaseURL: 'https://cards-against-humanity-35251.firebaseio.com',
    projectId: 'cards-against-humanity-35251',
    storageBucket: 'cards-against-humanity-35251.appspot.com',
    messagingSenderId: '801353822242',
    appId: '1:801353822242:web:4d3707569ca27ee4'
  })
  .database()
